import cuid from "cuid";
import { defaults, get, keyBy, map } from "lodash";
import { useState } from "react";
import { useQuery } from "shared/hooks/useApi";
import { INSURANCE_PLANS } from "utils/api/graphql/queries/insurance-plans";
import {
  CONTACT_POINT_SYSTEM,
  INSURANCE_PLAN_PARAMS_RULES,
} from "utils/constants";
import { buildDepartmentSkills } from "utils/helpers/address";
import { buildAcorisTerminationRequestPayload } from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/terminationRequest";
import { getMinDeltaStart } from "utils/helpers/array";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const AdherentBirthDate = ({
  project,
  onNext,
  onBack,
  currentStatus,
  tracer,
  territorial = false,
}) => {
  const [deltaStart, setDeltaStart] = useState(1);
  const [deltaRia, setDeltaRia] = useState(30);

  useQuery(INSURANCE_PLANS, {
    variables: { where: {} },
    onCompleted: ({ insurancePlans: { data: insurancePlans } }) => {
      setDeltaStart(
        getMinDeltaStart({
          insurancePlans,
          minValue: 1,
          key: INSURANCE_PLAN_PARAMS_RULES.DELTA_START,
        }),
      );
      setDeltaRia(
        getMinDeltaStart({
          insurancePlans,
          minValue: 30,
          key: INSURANCE_PLAN_PARAMS_RULES.DELTA_START_RIA,
        }),
      );
    },
  });

  const buildBasePayload = (formValues) => {
    const zipCode = get(
      formValues.telecoms,
      `${CONTACT_POINT_SYSTEM.ZIP_CODE}.value`,
      null,
    );
    const updatedTelecoms = map(formValues.telecoms, (item, key) =>
      defaults(
        { ...item, value: item?.value != null ? String(item.value) : null },
        { id: cuid(), system: key },
      ),
    );
    const fields = get(project, "fields", {});
    const skills = buildDepartmentSkills(get(fields, "skills", {}), zipCode);
    const isRia =
      formValues.hasOtherInsurer === true &&
      formValues.replaceContract === true &&
      formValues.contractOlderThanOneYear === true;
    const contact = {
      id: get(project, "contact.id") || cuid(),
      socialRegime: formValues.socialRegime,
      optMadelin: formValues.optMadelin || false,
      user: {
        id: get(project, "contact.user.id") || cuid(),
        birthDate: formValues.birthDate,
        firstname: get(project, "contact.user.firstname"),
        lastname: get(project, "contact.user.lastname"),
      },
      telecoms: updatedTelecoms,
      fields: {
        ...get(project, "contact.fields", {}),
        isClient: formValues.isClient,
        hasOtherInsurer: formValues.hasOtherInsurer,
        replaceContract: formValues.replaceContract,
        contractOlderThanOneYear: formValues.contractOlderThanOneYear,
      },
    };

    return {
      contact,
      contract: {
        id: get(project, "contract.id") || cuid(),
        issuanceDate: formValues.issuanceDate,
      },
      ria: isRia,
      terminationRequest: buildAcorisTerminationRequestPayload({
        terminationRequest: formValues.terminationRequest,
        contact,
        isRia,
      }),
      fields: {
        ...fields,
        skills,
        contractMoreThanOneYear: isRia,
        hasOtherInsurer: formValues.hasOtherInsurer === true,
        replaceContract: formValues.replaceContract === true,
        selfOccupation: isRia ? false : undefined,
      },
    };
  };

  const onSubmit = (formValues) => {
    return onNext({
      payload: buildBasePayload(formValues),
    });
  };

  const telecomsObject = defaults(
    keyBy(get(project, "contact.telecoms", []), "system"),
    {
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: { value: null },
      [CONTACT_POINT_SYSTEM.CITY]: { value: null },
      [CONTACT_POINT_SYSTEM.COUNTRY]: { value: null },
      [CONTACT_POINT_SYSTEM.PHONE]: { value: null },
      [CONTACT_POINT_SYSTEM.EMAIL]: { value: null },
    },
  );

  return (
    <>
      <Navbar project={project} currentStatus={currentStatus} tracer={tracer} />
      <View
        contact={get(project, "contact", {})}
        contract={get(project, "contract", {})}
        project={project}
        telecoms={telecomsObject}
        onNext={onSubmit}
        onBack={onBack}
        deltaStart={deltaStart}
        deltaRia={deltaRia}
        territorial={territorial}
      />
    </>
  );
};

export default AdherentBirthDate;
